import { useQuery } from 'react-query';
import request from '../helpers/request';

const createKey = (ids) => ['requestsByIds', ...ids];

const fetch = (ids, config = {}) => {
 const paramsStringify = {
  ids,
 }
  return request.post(
    `/Request/ids`,
    paramsStringify,
    config.errMsg || 'Не удалось загрузить указанные заявки',
    config.dataPlaceholder,
    undefined,
    undefined,
  );
}

const useFetch = (params, options) => {
  const { ids, ...fetchConfig } = params;
  return useQuery(createKey(ids), () => fetch(ids, fetchConfig), options);
};

const requestsByIdsQuery = {
  createKey,
  fetch,
  useFetch,
};

export default requestsByIdsQuery;
